module.exports = __webpack_public_path__ + "static/media/iconExamF.6a58c605.svg";